import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { translations } from 'src/constants/translations';
import { BoxFormTextField } from 'src/components/profileComponents/FormTextField';
import { SubGroupWrapper } from 'src/components/profileComponents/Marketplace/components/SubGroupWrapper';
import {
  useStyles as mainUseStyles,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/components/Common/styles';
import {
  UploadMarketplace,
} from 'src/components/profileComponents/Marketplace/components/Filters/components/UploadMarketplace';
import {
  IDevelopmentSpecificationPropChange,
} from 'src/components/profileComponents/Complexes/components/ProjectSpecification/types';
import { BoxFormAutocomplete } from 'src/components/profileComponents/FormAutocomplete';
import {
  UnitStyle,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/components/Common/components/UnitStyle';
import { IMarketplacePlacementProperty, Option } from 'src/components/profileComponents/Marketplace/types';
import {
  IMarketplacePlacementCardFirstHeaderMainElement,
} from 'src/typings/marketplaceTile';
import { readURL } from 'src/helpers';
import { updateTranslatedField } from 'src/components/profileComponents/Marketplace/components/Filters/helpers';

export const UnitsCardMainSecondaryEntity: React.FC<{
  title: string;
  entity: IMarketplacePlacementCardFirstHeaderMainElement,
  onChange: (entity: IMarketplacePlacementCardFirstHeaderMainElement) => void,
  lang: string,
  propertyOptions: Option<IMarketplacePlacementProperty>[],
  moveToTrash: () => void
}> = ({
  title, entity, onChange, lang, propertyOptions, moveToTrash,
}) => {
  const [image, setImage] = useState<string | null>(entity.iconFileUri?.fileUrl || null);
  const stylesConfig = ['fontWeight', 'fontDecoration', 'fontColor'];
  const mainStyles = mainUseStyles();
  return (
    <SubGroupWrapper
      name={title}
      onTrash={() => moveToTrash()}
      customOffsetStyles={mainStyles.customOffsetStyles}
    >
      <Box display="flex" gap="20px">
        <Box>
          <UploadMarketplace
            register={() => {}}
            registerName=""
            image={image}
            onUpload={async (file, response) => {
              onChange({ ...entity, iconFileUri: response.data[0] });
              const base64: string = await readURL(file);
              if (base64) {
                setImage(base64);
              }
            }}
            onMoveToTrash={() => {
              onChange({ ...entity, iconFileUri: null });
              setImage(null);
            }}
          />
        </Box>
        <Box display="flex" flexDirection="column" flex="auto">
          <Box display="flex" gap="20px">
            <div className={mainStyles.prefixSuffixWrapper}>
              <BoxFormTextField
                label={translations.prefix}
                name="prefix"
                defaultValue={entity.prefix?.[lang]}
                onChange={(event) => {
                  onChange(updateTranslatedField(entity, 'prefix', lang, event.target.value));
                }}
              />
            </div>
            <div className={mainStyles.selectWrapper}>
              <BoxFormAutocomplete
                label={translations.propertyName}
                name="property"
                propertyToCompare="systemName"
                defaultValue={{ label: entity.property?.translates?.[lang] || entity.property?.systemName, value: entity.property }}
                onChange={(event: IDevelopmentSpecificationPropChange<IMarketplacePlacementProperty>) => {
                  onChange({ ...entity, property: event.value });
                }}
                options={propertyOptions}
              />
            </div>
            <div className={mainStyles.prefixSuffixWrapper}>
              <BoxFormTextField
                label={translations.suffix}
                name="suffix"
                defaultValue={entity.suffix?.[lang]}
                onChange={(event) => {
                  onChange(updateTranslatedField(entity, 'suffix', lang, event.target.value));
                }}
              />
            </div>
          </Box>
          <UnitStyle
            entityConfig={stylesConfig}
            entityStyles={entity.styles}
            updateProperty={(property, value) => {
              if (entity.styles) {
                onChange({ ...entity, styles: { ...entity.styles, [property]: value } });
              }
            }}
          />
        </Box>
      </Box>
    </SubGroupWrapper>
  );
};
